module.exports = __webpack_public_path__ + "static/img/8.4819121.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/8.png
// module id = XxiY
// module chunks = 0